export class WebglSettingsConverter {
  constructor() {}

  convert(/*settings*/) {
    return undefined;
  }
}
